import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicDatasourcesForm',
  mixins: [formMixin],
  props: {},
  data: function () {
    return {
      fieldsDisabled: {
        server: ['auto_id', 'filesystem', 'webhook'],
        server_rest: ['auto_id', 'filesystem', 'webhook'],
        server_mqtt: ['auto_id', 'filesystem', 'webhook'],
        tcpPort: ['auto_id', 'filesystem', 'webhook'],
        udpPort: ['auto_id', 'filesystem', 'webhook'],
        useTLS: ['auto_id', 'filesystem', 'webhook']
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    statusItems() {
      return ['public', 'private'].map(s => {
        return {
          text: this.$i18n_t(`NiotaClassic.DataSources.form.status_${s}`),
          value: s
        };
      });
    },
    dataSourceButtons() {
      return this.formCardButtons.map(button => {
        if (button.icon !== 'fas fa-save') {
          return button;
        }
        return {
          ...button,
          valid: this.isSuperSystemAdmin === true ? undefined : false
        };
      });
    },
    isFirefly() {
      if (this.formItem.type === 'firefly' || this.formItem.type === 'firefly_mqtt') {
        return true;
      }
      return false;
    }
  },
  watch: {},
  created() {
    this.formItem = cloneDeep(this.editedItem);
    if (!this.formItem.properties) {
      this.formItem.properties = {};
    }
  },
  methods: {
    isFieldEnabled(fieldId) {
      return this.fieldsDisabled[fieldId].findIndex(type => type === this.formItem.type) < 0;
    },
    updateRequest() {
      return NiotaClassicApiService.dataSourcesUpdate(this.formItem.id, this.formItem);
    },
    createRequest() {
      return NiotaClassicApiService.dataSourcesCreate(this.formItem);
    },
    uploadImage(image) {
      NiotaClassicApiService.uploadImage(image, 'datasource').then(data => {
        this.formItem.image = data.file;
      }).catch(error => {
        // TODO: create toast with error message
        console.error('Error during image upload', error);
      });
    }
  }
};